module.exports = __webpack_public_path__ + "img/473-3a6bf1.png";